export const BLOG_UI_TEXT_QUERY = `
  query BlogUIText($locale: SiteLocale!) {
    allBlogUiTexts(locale: $locale) {
      slug
      text
    }
  }
`
